const Loading = () =>{
 return <div className="preloader">
  <img src={require('../../assets/images/galaxy-logo.png')} alt="image" width={100}/>
  </div>
}

export default Loading;